import { revalidateLogic, type ValidationLogicFn } from '@tanstack/react-form'

/**
 * `revalidateLogic()` ajoute le validateur « dynamic » à CHAQUE passe de validation (la passe
 * synchrone puis la passe asynchrone). Avec un schéma vine (validation async-only), la passe
 * SYNCHRONE voit `fn: undefined` mais `FormGroupApi.distributeFieldErrors` efface malgré tout les
 * erreurs déjà distribuées aux champs — juste avant que la passe ASYNCHRONE ne les repose. Résultat :
 * à chaque frappe, toutes les erreurs de l'étape clignotent (disparaissent puis réapparaissent).
 *
 * On retire donc de chaque passe les validateurs sans `fn` : le nettoyage légitime (un champ qui
 * redevient valide) reste assuré par la passe asynchrone, qui, elle, exécute réellement le schéma.
 * On conserve ainsi le comportement de `revalidateLogic()` (rien avant le 1er submit, puis live).
 */
export const revalidateLogicWithoutFlicker = (): ValidationLogicFn => {
  const logic = revalidateLogic()
  return (props) =>
    logic({
      ...props,
      runValidation: ({ validators, form }) =>
        props.runValidation({ validators: validators.filter((validator) => validator?.fn), form }),
    })
}
